const AdminDashboard = () => {
  return (
    <div>
      <h1>Admin Dashboard</h1>

      <ul>
        <li>Manage Notices</li>
        <li>View Bookings</li>
        <li>Add / Delete Notices</li>
      </ul>
    </div>
  );
};

export default AdminDashboard;
